import { isEmail } from '@active/core/email/validate';

export const emailParse = (email) => {
  if (!email) {
    return undefined;
  }
  const isValidateEmail = isEmail(email);
  return isValidateEmail ? email : undefined;
};
